/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function EmojiFlag({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.753 1.453a.596.596 0 0 1 .258-.053h5.642A1.6 1.6 0 0 1 9.23 2.737l.11.663H13.5a.6.6 0 0 1 .537.868l-1.325 2.65 2.249 2.698a.6.6 0 0 1-.461.984H8.78A1.6 1.6 0 0 1 7.23 9.388L7.032 8.6H3.708l.884 5.301a.6.6 0 1 1-1.184.198l-.998-5.99a.6.6 0 0 1-.003-.02l-.997-5.98a.6.6 0 0 1 .343-.656ZM7.513 7.4H3.508l-.8-4.8h4.945a.4.4 0 0 1 .394.334l.667 4a.4.4 0 0 1-.394.466h-.807Zm.755 1.2.125.497a.4.4 0 0 0 .388.303h4.438l-1.68-2.016a.6.6 0 0 1-.076-.652L12.53 4.6H9.542l.356 2.137A1.6 1.6 0 0 1 8.32 8.6h-.052Z" clipRule="evenodd" /></svg>;
}
;